import { MentionRenderer, hasMentionMarkers } from "./MentionRenderer";

/**
 * The user's own words, exactly as typed — running them through a markdown
 * parser would eat their asterisks and underscores.
 *
 * With a `title` (a workflow section's name for a long generated first message, see
 * `workflows/`), the text folds under that title and opens on click.
 */
export function UserMessageText({ text, title }: { text: string; title?: string | undefined }) {
  const body = (
    <div className="chat-msg-text">
      {hasMentionMarkers(text) ? <MentionRenderer content={text} /> : text}
    </div>
  );
  if (!title) return body;
  return (
    <details className="chat-workflow-message">
      <summary>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="9" y="3" width="6" height="4" rx="1" />
          <path d="M9 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3M12 12h4M12 16h4M8 12h.01M8 16h.01" />
        </svg>
        <span>{title}</span>
        <svg className="chat-workflow-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m9 5 7 7-7 7" />
        </svg>
      </summary>
      {body}
    </details>
  );
}
